import { render } from "./PcFooter.vue?vue&type=template&id=5e7cd9bf"
const script = {}

import "./PcFooter.vue?vue&type=style&index=0&id=5e7cd9bf&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_1e77ff55b92932984816aac78a22ff52/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__